export default __webpack_public_path__ + "static/media/kitchen3-afterF-480w.0f716487.webp";